// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"46289ba9","454":"808066cb","526":"3e75493d","883":"31a40ca3","966":"3e75493d"}[chunkId] + ".chunk.css";
};